export default __webpack_public_path__ + "static/applet-19-set-1-103ee4b6f07ecc06b9268094aabffe3d.webp";